<template>
  <p class="error" v-if="getErrorData">{{ getErrorData }}</p>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["errorName"],
  computed: {
    getErrorData() {
      return this.getErrors && this.errorName && this.getErrors[this.errorName]
        ? this.getErrors[this.errorName]
        : "";
    },
    ...mapGetters("errors", ["getErrors"]),
  },
};
</script>
